var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#25262F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0959 34.001V29.408C17.0959 28.613 17.4119 27.85 17.9749 27.287C18.5379 26.724 19.3009 26.408 20.0959 26.408H27.9119C28.7069 26.408 29.4699 26.724 30.0329 27.287C30.5959 27.85 30.9119 28.613 30.9119 29.408V34.001H32.0039C32.5339 34.001 33.0429 33.79 33.4179 33.415C33.7929 33.04 34.0039 32.531 34.0039 32.001C34.0039 28.745 34.0039 22.442 34.0039 20.249C34.0039 19.75 33.8179 19.27 33.4819 18.901C32.5469 17.876 30.5939 15.734 29.6089 14.653C29.2299 14.238 28.6939 14.001 28.1309 14.001C25.7779 14.001 19.3089 14.001 16.0039 14.001C15.4739 14.001 14.9649 14.212 14.5899 14.587C14.2149 14.962 14.0039 15.471 14.0039 16.001C14.0039 19.833 14.0039 28.169 14.0039 32.001C14.0039 32.531 14.2149 33.04 14.5899 33.415C14.9649 33.79 15.4739 34.001 16.0039 34.001H17.0959ZM19.0959 34.001V29.408C19.0959 29.143 19.2019 28.889 19.3889 28.701C19.5769 28.514 19.8309 28.408 20.0959 28.408H27.9119C28.1769 28.408 28.4309 28.514 28.6189 28.701C28.8059 28.889 28.9119 29.143 28.9119 29.408V34.001H19.0959Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSave);
export default __webpack_public_path__ + "static/media/icon_save.a5b64fd33c6c585db9ad31abd2d67f40.svg";
export { ForwardRef as ReactComponent };